<template>
  <v-dialog v-model="visible" persistent max-width="500">
    <v-card class="text-left">
      <v-card-title>Confirm account changes</v-card-title>
      <v-card-text class="text-left">
        <p class="text-left">{{ otherUser ? 'Enter your own current password to confirm changes to this user. Do not enter the other user’s password.' : 'Enter your current password to confirm these account changes.' }}</p>
        <v-alert class="text-left" v-if="error" type="error" outlined>{{ error }}</v-alert>
        <v-text-field v-model="password" type="password" autocomplete="current-password"
          label="Your current password" outlined autofocus :disabled="submitting"
          @keyup.enter="confirm" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="submitting" @click="cancel">{{ $t('cancel') }}</v-btn>
        <v-btn text color="primary" :loading="submitting" :disabled="!password || submitting"
          @click="confirm">{{ $t('user.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: { otherUser: Boolean },
  data() {
    return { visible: false, password: '', error: '', submitting: false };
  },
  beforeDestroy() { this.finish(null); },
  methods: {
    request(operation) {
      this.password = '';
      this.error = '';
      this.operation = operation;
      this.visible = true;
      return new Promise(resolve => { this.resolveRequest = resolve; });
    },
    finish(result) {
      this.visible = false;
      this.password = '';
      this.error = '';
      this.operation = null;
      const resolve = this.resolveRequest;
      this.resolveRequest = null;
      if (resolve) resolve(result);
    },
    cancel() { if (!this.submitting) this.finish(null); },
    async confirm() {
      if (!this.password || this.submitting) return;
      this.submitting = true;
      this.error = '';
      try {
        const operation = this.operation;
        const result = await operation(this.password);
        this.finish(result);
      } catch (error) {
        if (error.sessionExpiryHandled) { this.finish(null); return; }
        const data = error.response && error.response.data;
        this.error = typeof data === 'string' ? data :
          (data && (data.message || data.error)) || 'Unable to save changes. Please try again.';
        this.password = '';
      } finally { this.submitting = false; }
    }
  }
};
</script>
